import { render, staticRenderFns } from "./BuildingInfo.vue?vue&type=template&id=d09bbd62&scoped=true"
import script from "./BuildingInfo.vue?vue&type=script&lang=js"
export * from "./BuildingInfo.vue?vue&type=script&lang=js"
import style0 from "./BuildingInfo.vue?vue&type=style&index=0&id=d09bbd62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09bbd62",
  null
  
)

export default component.exports